import { Button, PersonAddIcon } from '@blueprinthq/joy'
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue
} from '@chakra-ui/react'
import { useStoreActions, useStoreState } from 'easy-peasy'
import React, { useState } from 'react'

import { EnrollmentForm, SubmittedView } from './components'

export function QuickEnroll(props) {
  const [isSubmitted, setSubmitted] = useState(false)
  const { isQuickEnrollOpen } = useStoreState(state => state.quickEnroll)
  const { setIsQuickEnrollOpen } = useStoreActions(
    actions => actions.quickEnroll
  )

  const handleClose = () => {
    setSubmitted(false)
    setIsQuickEnrollOpen(false)
  }

  const modalSize = useBreakpointValue({
    base: 'full',
    md: 'lg'
  })

  return (
    <>
      <Button
        id="quick-enroll-link"
        onClick={() => setIsQuickEnrollOpen(true)}
        h="40px"
        ml="0"
        size="lg"
      >
        <PersonAddIcon size="sm" fill="white" mr="5px" mt="5px" />
        {'Add Client'}
      </Button>
      <Modal
        onClose={handleClose}
        size={modalSize}
        isOpen={isQuickEnrollOpen}
        preserveScrollBarGap
        {...props}
      >
        <ModalOverlay />
        <ModalContent p="small">
          <ModalHeader pb="0">Enroll a client on Blueprint</ModalHeader>
          <ModalCloseButton />
          {isSubmitted
            ? <SubmittedView
                setSubmitted={setSubmitted}
                handleClose={handleClose}
              />
            : <EnrollmentForm setSubmitted={setSubmitted} />}
        </ModalContent>
      </Modal>
    </>
  )
}
